import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { OwnTeam } from 'interfaces/own-team.interface';
import { getPublicPath } from 'utils/paths';
import {
  StyledHero,
  StyledHeroActions,
  StyledHeroContainer,
  StyledHeroImage,
  StyledHeroScroll,
  StyledHeroScrollMouse,
  StyledHeroScrollMouseBall,
  StyledHeroScrollText,
  StyledHeroStars,
  StyledHeroText,
  StyledHeroTitle
} from './BringYourOwnTeamHero.styled';

type BringYourOwnTeamHeroProps = {
  teams: OwnTeam[];
};

const BringYourOwnTeamHero: React.FC<BringYourOwnTeamHeroProps> = ({
  teams
}) => {
  const { t } = useI18n('bring-your-own-team');

  return (
    <StyledHero>
      <StyledHeroStars />
      <StyledHeroContainer>
        <StyledHeroText>
          <StyledHeroTitle>{t('hero.title')}</StyledHeroTitle>
          <p>{t('hero.desc')}</p>
          {teams?.length > 0 && (
            <StyledHeroActions>
              <ButtonLink href="#teams" variant="primary" sizes="md">
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>{t('hero.CTA')}</span>
              </ButtonLink>
            </StyledHeroActions>
          )}
        </StyledHeroText>
        <StyledHeroImage>
          <img
            src={getPublicPath('/images/bringYourOwnTeam/space-ship.svg')}
            alt=""
          />
        </StyledHeroImage>
      </StyledHeroContainer>
      <StyledHeroScroll href="#teams">
        <StyledHeroScrollMouse>
          <StyledHeroScrollMouseBall />
        </StyledHeroScrollMouse>
        <StyledHeroScrollText>
          <HtmlTrans ns={'bring-your-own-team'} i18nKey={'hero.scrollText'} />
        </StyledHeroScrollText>
      </StyledHeroScroll>
    </StyledHero>
  );
};

export default BringYourOwnTeamHero;
